import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function AudioReplayFailureDialog({ onDismiss, isOpen }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      type="failure"
      heading={t("activityLog.audioReplayFailure.heading")}
      text={t("activityLog.audioReplayFailure.text")}
      buttons={[{ text: t("buttons.ok"), onClick: onDismiss }]}
    />
  );
}
